import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import type { i18n as I18nType } from "i18next";

interface AppProps {
  i18n: I18nType;
}

function App({ i18n }: AppProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <AppRoutes />
    </I18nextProvider>
  );
}

export default App;
